/**
 * Abre numa aba nova um PDF que veio no CORPO de uma resposta, não numa URL.
 *
 * O padrão do resto do app (`window.open(urlDeArquivo(...))`) só serve para
 * GET. A prévia de layout é POST, porque previsualiza um layout que ainda não
 * foi salvo — então o arquivo chega como blob e precisa de object URL.
 *
 * ⚠️ **A aba é aberta ANTES do `await`.** Depois de um await o clique já saiu
 * da pilha de gesto do usuário, e o bloqueador de pop-up (Safari e iOS em
 * especial) mata o `window.open`. Abrir vazia e depois navegar é o que
 * funciona nos três navegadores.
 *
 * ⚠️ E `noopener` fica DE FORA desta chamada de propósito: com ele, vários
 * navegadores devolvem `null` em vez da referência da janela, e não haveria
 * como apontá-la para o blob depois. A aba é `about:blank` de mesma origem,
 * sem `opener` explorável.
 */
export async function abrirPdfDeBlob(gerar: () => Promise<Blob>): Promise<void> {
  const janela = window.open('', '_blank');

  try {
    const url = URL.createObjectURL(await gerar());

    // Pop-up bloqueado mesmo assim: navega na própria aba em vez de o clique
    // não fazer nada — o usuário volta com o botão de voltar.
    if (janela) janela.location.href = url;
    else window.location.href = url;

    // ⚠️ O revoke NÃO pode ser imediato: a outra aba ainda não terminou de
    // buscar o blob quando esta função retorna, e revogar na hora entrega uma
    // aba em branco. Não existe evento de "a outra aba carregou", então o
    // timeout é a única saída. O custo é segurar o PDF em memória por 1 minuto.
    window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
  } catch (erro) {
    janela?.close();
    throw erro;
  }
}
